import { colors, size, typography, mediaQueries } from '@everlywell/leaves';
import { Link } from 'gatsby';
import styled, { css } from 'styled-components';

export const Wrapper = styled.nav`
  display: flex;
`;

const commonCrumb = `
  ${typography.buttonTextSmall};
`;
export const Crumb = styled(Link)<{ showNewAboveTheFoldPdp: boolean }>`
  ${({ showNewAboveTheFoldPdp }) =>
    showNewAboveTheFoldPdp
      ? css`
          font-size: ${size.md}px;
          color: ${colors.green4};
          text-decoration: none;
          white-space: nowrap;

          ${mediaQueries.forTabletHorizontalUp} {
            ${commonCrumb};
          }
        `
      : css`
          ${commonCrumb};
          color: ${colors.green4};
          text-decoration: none;
          white-space: nowrap;
        `};
`;
export const Divider = styled.span<{ showNewAboveTheFoldPdp: boolean }>`
  ${({ showNewAboveTheFoldPdp }) =>
    showNewAboveTheFoldPdp
      ? css`
          font-size: ${size.md}px;
          color: ${colors.green4};
          padding: 0 ${size.xs2}px;

          ${mediaQueries.forTabletHorizontalUp} {
            ${commonCrumb};
          }
        `
      : css`
          ${commonCrumb};
          color: ${colors.green4};
          padding: 0 ${size.xs2}px;
        `};
`;
export const CurrentCrumb = styled.span<{
  showNewAboveTheFoldPdp: boolean;
}>`
  ${({ showNewAboveTheFoldPdp }) =>
    showNewAboveTheFoldPdp
      ? css`
          font-size: ${size.md}px;
          color: ${colors.gray4};
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          ${mediaQueries.forTabletHorizontalUp} {
            ${commonCrumb};
          }
        `
      : css`
          ${commonCrumb};
          color: ${colors.gray4};
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        `};
`;
